import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Ellipse } from "react-native-svg";

export const IconFormOval: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormOval"><Ellipse cx="11.75" cy="12" rx="9.75" ry="7.75" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormOval;
